



import { Vue, Component } from 'vue-property-decorator';
import SurveyComponent from './survey.component.vue';

@Component({
  components: {
    SurveyComponent,
  },
})
export default class Survey extends Vue {
}
